import axios from 'axios';
const jwt= sessionStorage&&sessionStorage.getItem('jwt')?sessionStorage.getItem('jwt'):'';
//https://stackoverflow.com/questions/56416944/how-to-combine-vue-cli-development-mode-with-server-side-api
const Axios = axios.create({
  //baseURL: 'http://booking.jslab.it/ajax',
  baseURL: '/ajax',
  withCredentials: false,
  timeout: 350000,
  //mode: 'no-cors',
  headers: {
      'Accept': 'application/json',
      'Authorization': jwt,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires':'0'
  },/*
  proxy:{
    protocol:'http',
    host:'127.0.0.1',
    port:80
  }*/
})
Axios.interceptors.request.use(request => {
  request.headers['Authorization']= sessionStorage.getItem('jwt');
  request.headers['X-CSRF-TOKEN']= sessionStorage.getItem('csrf');
  request.headers['X-VERSION']= localStorage.getItem('version');
  return request;
})
/*
Axios.interceptors.response.use(
  (resp) => {
    let v = resp.headers['X-VERSION'] || 'default'
    console.log(32,'axios.js',v)
    if(v !== localStorage.getItem('version') && resp.config.method == 'get')
    {
      localStorage.setItem('version', v)
      console.log(36,'axios.js',v)
      window.location.reload() // For new version, simply reload on any get
     }
     else
     {
      console.log(41,'axios.js',v)
     }
  return Promise.resolve(resp)
})
*/

//Axios.defaults.headers.common['X-CSRF-TOKEN']=sessionStorage.getItem('csfr');
//Axios.defaults.headers.post['Authorization']=sessionStorage.getItem('jwt');
//Axios.defaults.headers.post['Cache-Control']='no-cache, no-store, must-revalidate';
Axios.defaults.headers.get['Cache-Control']='no-cache, no-store, must-revalidate';
//Axios.defaults.headers.post['Content-Type']='application/json';
export default Axios;